/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Location_Opted_Out_MessageInputs */

const en_ticket_location_opted_out_message = /** @type {(inputs: Ticket_Location_Opted_Out_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The customer cannot see your live position. ServiceNow status updates still work normally. Turn on the toggle above to share again.`)
};

const ja_ticket_location_opted_out_message = /** @type {(inputs: Ticket_Location_Opted_Out_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お客様には現在地が表示されません。ServiceNowのステータス更新は通常どおり動作します。共有を再開するには、上のスイッチをオンにしてください。`)
};

const fr_ticket_location_opted_out_message = /** @type {(inputs: Ticket_Location_Opted_Out_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le client ne voit pas votre position en direct. Les mises à jour de statut ServiceNow continuent normalement. Activez le bouton ci-dessus pour partager à nouveau.`)
};

const de_ticket_location_opted_out_message = /** @type {(inputs: Ticket_Location_Opted_Out_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Kunde sieht Ihre Live-Position nicht. ServiceNow-Statusmeldungen funktionieren weiterhin normal. Schalten Sie den Schalter oben ein, um wieder zu teilen.`)
};

/**
* | output |
* | --- |
* | "The customer cannot see your live position. ServiceNow status updates still work normally. Turn on the toggle above to share again." |
*
* @param {Ticket_Location_Opted_Out_MessageInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_location_opted_out_message = /** @type {((inputs?: Ticket_Location_Opted_Out_MessageInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Location_Opted_Out_MessageInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_location_opted_out_message(inputs)
	if (locale === "ja") return ja_ticket_location_opted_out_message(inputs)
	if (locale === "fr") return fr_ticket_location_opted_out_message(inputs)
	return de_ticket_location_opted_out_message(inputs)
});